import React from "react";

const OrbitView = () => {
  return (
    <div className="relative w-[600px] h-[600px] mx-auto">
      {/* Background Shape Image */}
      <img
        src="//www.zohowebstatic.com/sites/zweb/images/crm/crm-360deg-animation-shape.svg"
        alt="Background Shape"
        className="absolute inset-0 w-full h-full object-cover z-10 animate-spin-slow"
      />

      {/* Rotating Circle Image */}
      <img
        src="//www.zohowebstatic.com/sites/zweb/images/crm/crm-360deg-animation-circle.svg"
        alt="Rotating Circle"
        className="absolute inset-0 w-full h-full object-cover z-20 animate-spin-reverse"
      />
    </div>
  );
};

export default OrbitView;
